import React from 'react';

const P4 = (props) => {
  let classes = ['_P4'];
  const style = props.style;
  if (props.classes) {
    classes = classes.concat(props.classes);
  }
  if (props.className) {
    classes.push(props.className);
  }
  return <p className={classes.join(' ')} style={style}>{props.children}</p>;
};

export default React.memo(P4);
